import { IFrameProps } from 'shared/types';

export const FacebookIFrame = (props: IFrameProps): JSX.Element => {
  const { src, containerWidth, ...iframeProps } = props;

  // Facebook lays out both the player and its "Video Unavailable" card at the `width` param. The player stays
  // responsive at any value, but the error card does not, so pass the real container width.
  const pxHeight = Math.round(containerWidth * (9 / 16));
  const urlEncodedSrc = encodeURI(src);
  const fullSrc = `https://www.facebook.com/plugins/video.php?href=${urlEncodedSrc}&width=${containerWidth}&height=${pxHeight}&show_text=false&t=0`;

  return (
    <iframe
      src={fullSrc}
      {...iframeProps}
      allowFullScreen={false} // this doesn't work on iOS, but it's necessary for Android as the back button from fullscreen goes back in the app as well
      allow="clipboard-write; encrypted-media; picture-in-picture; web-share"
      title="Facebook Video"
      scrolling="no"
    />
  );
};
